import { Component, Inject, OnDestroy } from '@angular/core';

import { DialogService } from '../../../../../common/services/dialog.service';

import { SIDE_EFFECT_DATA_TOKEN, SideEffectData } from '../models/types';
import { AdditionalContactDataTypes, ContactItem } from './contact-item/models/contact-item';

@Component({
    selector: 'side-effect-load-contact-data',
    templateUrl: './side-effect-contact-data.component.html',
    styleUrls: ['./side-effect-contact-data.component.scss'],
    standalone: false
})
export class SideEffectContactDataComponent implements OnDestroy {
  public dataObject: any;
  public contacts: ContactItem[];
  public idx: number;

  constructor(
    @Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData,
    public dialogService: DialogService
  ) {
    if (data.template.context.model.data)
      this.dataObject = Object.assign({}, data.template.context.model.data);

    if (!data.sideEffect.configuration.contacts)
      data.sideEffect.configuration.contacts = [];

    this.contacts = data.configuration.contacts;
    this.contacts.forEach((x) => { (x as any).edit = false });
  }

  ngOnDestroy() {
    this.contacts.forEach(x => delete (x as any).edit);
  }

  public createContact(): void {
    this.contacts.push(<any & ContactItem>{ edit: true, dataType: AdditionalContactDataTypes.None });
  }

  public deleteContact(idx: number): void {
    this.idx = idx;
    this.dialogService.openDialog('confirmCancel', 'Confirm Deletion of contact.');
  }

  public defaultConfiguration(): Config {
    return {
      contacts: []
    }
  }

  public onDialogConfirm(): void {
    this.dialogService.closeDialog();
    this.contacts.splice(this.idx, 1);
  }

  public onDialogClose(): void {
    this.dialogService.closeDialog();
  }

}

interface Config {
  contacts: ContactItem[]
}
